<script setup lang="ts">
import type { ContentBlockParagraph } from '@nimbus/types'

const props = defineProps<ContentBlockParagraph>()
</script>

<template>
    <p>
        <NimbusContentBlockRenderer :content="props.children" :new-tab-links="props?.newTabLinks" />
    </p>
</template>
